export function renderSpinner(mount?: HTMLElement | null): HTMLDivElement {
	const target =
		mount ?? document.getElementById('nav-toggle-btn') ?? document.body
	target.insertAdjacentHTML('beforeend', '<div class="spinner"></div>')

	const spinner = target.lastElementChild
	if (!(spinner instanceof HTMLDivElement)) {
		throw new Error('Failed to render spinner.')
	}
	return spinner
}
